import React from "react";

const NotFound = () => {
  return <div className="flex items-center justify-center h-screen w-full text-xl">Sorry! This page could not be found.</div>;
};

export default NotFound;
